import { dailyNoteId, RecordType, type DailyNoteRecord } from '@wiztime/core';
import type { WriteSession } from './session';

/** Save the note of `date` (deterministic id; the last write wins across devices). */
export async function saveNote(session: WriteSession, date: string, text: string): Promise<DailyNoteRecord> {
  const id = dailyNoteId(date);
  const existing = await session.find(id);
  if (existing !== null && existing.type === RecordType.DailyNote && existing.data?.text === text) {
    return existing;
  }
  return session.write(RecordType.DailyNote, id, { personalDate: date, text });
}
